<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.orders.nearest_shipment_by_supplier') }}
      </h1>
      <div class="ml-auto">
        <download-excel
          file-name="nearest-shipment-by-suppliers.xlsx"
          :url="`/order-reports/nearest-shipment-by-suppliers-xlsx`"
          :filters="excelFilters"
          :params="params"
        />
        <v-btn
          outlined
          large
          @click="toggleFilters"
        >
          <v-icon left>
            mdi-filter-variant
          </v-icon>
          {{ $t('common.filter') }}
        </v-btn>
      </div>
    </div>
    <nearest-shipment-filter
      v-model="filtersShown"
      :filters="filters"
      :no-items-found="noItemsFound"
      @change="filters = $event"
      @search="getItems($event, true)"
    />
    <v-data-table
      v-if="items.length"
      fixed-header
      :headers="headers"
      :items="items"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
      }"
      :loading-text="$t('common.loading_data')"
    >
      <template v-slot:item.date="{ item }">
        {{ $moment(item.date).format('L') }}
      </template>
      <template v-slot:item.lastDate="{ item }">
        {{ $moment(item.lastDate).format('L') }}
      </template>
      <template v-slot:item.supplierASDB="{ item }">
        <router-link
          :to="{
            name: 'NearestShipment',
            params: {
              supplier: item.supplierASDB,
              plant: filters.plant || undefined,
              part: filters.part || undefined,
              date: item.date || undefined
            }
          }"
        >
          {{ item.supplierASDB }}
        </router-link>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import NearestShipmentBySupplierFilter from '@/components/orders/NearestShipmentBySupplierFilter.vue';
import DownloadExcel from '@/components/common/DownloadExcel.vue';

export default {
  name: 'NearestShipmentBySuppliers',
  components: {
    NearestShipmentFilter: NearestShipmentBySupplierFilter,
    DownloadExcel,
  },
  data() {
    return {
      total: 0,
      items: [],
      loading: false,
      noItemsFound: false,
      options: {
        page: 1,
      },
      headers: [],
      filtersShown: true,
      filters: {
        plant: '',
        supplier: '',
        supplierType: '',
        consolidator: '',
        part: '',
        analyst: '',
        country: '',
      },
    };
  },
  computed: {
    params() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const params = Array.from(Object.entries(this.filters)).reduce((acc, [key, value]) => {
        if (value) {
          acc[key] = value;
        }
        return acc;
      }, {});

      if (itemsPerPage !== -1) {
        params.pageSize = itemsPerPage;
        params.page = page;
      }

      if (sortBy && sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      return params;
    },
    excelFilters() {
      return [{
        key: 'plant',
        value: this.filters.plant,
        required: true,
      }, {
        key: 'supplier',
        value: this.filters.supplier,
      }, {
        key: 'supplierType',
        value: this.filters.supplierType,
      }, {
        key: 'consolidator',
        value: this.filters.consolidator,
      }, {
        key: 'part',
        value: this.filters.part,
      }, {
        key: 'analyst',
        value: this.filters.analyst,
      }, {
        key: 'country',
        value: this.filters.country,
      }];
    },
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },
  methods: {
    async getItems(filters, filtered) {
      this.loading = true;

      if (filtered) {
        this.options.page = 1;
      }

      if (filters) {
        this.filters = filters;
      }

      try {
        const { data = {} } = await this.$http.get('order-reports/nearest-shipment-by-suppliers', { params: this.params });

        if ((data.items || []).length) {
          this.noItemsFound = false;

          this.headers = data.headers;
        } else {
          this.noItemsFound = true;
        }

        this.items = (data.items || []).map((item) => ({
          ...item,
          date: item.date && this.$moment(item.date, 'DD.MM.YYYY').toDate(),
          lastDate: item.lastDate && this.$moment(item.lastDate, 'DD.MM.YYYY').toDate(),
        }));
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },
    toggleFilters() {
      if (this.items.length) {
        this.filtersShown = !this.filtersShown;
        return;
      }
      this.filtersShown = true;
    },
  },
};
</script>
